module.exports = __webpack_public_path__ + "static/img/152.1a02285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/152.png
// module id = +FjP
// module chunks = 0